export enum MEASUREMENT_TYPE {
  CAST = 'cast',
  CHARACTER = 'character'
}
